"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StoryType = void 0;
var StoryType;
(function (StoryType) {
    StoryType["listicle"] = "listicle";
    StoryType["similarFriend"] = "similarFriend";
    StoryType["similarFriendsList"] = "similarFriendsList";
    StoryType["friendComparison"] = "friendComparison";
    StoryType["allUserComparison"] = "allUserComparison";
    StoryType["thematicSimilarity"] = "thematicSimilarity";
    StoryType["loveAlginment"] = "loveAlignment";
    StoryType["friendNutshell"] = "friendNutshell";
    StoryType["twoByTwo"] = "twoByTwo";
    StoryType["peerSignatureNonSignature"] = "peerSignatureNonSignature";
})(StoryType = exports.StoryType || (exports.StoryType = {}));
